/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ManifestModelEditorViewModel } from '../models/manifest-model-editor-view-model';
import { ManifestModel } from '../models/manifest-model';
import { ManifestModelQueryResponseViewModel } from '../models/manifest-model-query-response-view-model';
import { ManifestPatientsQueryModel } from '../models/manifest-patients-query-model';
import { AddManifestPatientsModel } from '../models/add-manifest-patients-model';
import { PatientManifestMappingModel } from '../models/patient-manifest-mapping-model';
@Injectable({
  providedIn: 'root',
})
class ManifestService extends __BaseService {
  static readonly GetPath = '/view/jpats/manifest';
  static readonly SavePath = '/view/jpats/manifest';
  static readonly GetByKeyPath = '/view/jpats/manifest/{manifestKey}';
  static readonly QueryPath = '/view/jpats/manifest/Query';
  static readonly SavePatientsToManifestPath = '/view/jpats/manifest/{manifestKey}/SavePatientsToManifest';
  static readonly GetAvailablePatientsPath = '/view/jpats/manifest/{manifestKey}/GetAvailablePatients';
  static readonly GetAssignedPatientsPath = '/view/jpats/manifest/{manifestKey}/GetAssignedPatients';
  static readonly AddPatientPath = '/view/jpats/manifest/{manifestKey}/AddPatient';
  static readonly RemovePatientPath = '/view/jpats/manifest/{manifestKey}/RemovePatient';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetResponse(): __Observable<__StrictHttpResponse<ManifestModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/manifest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelEditorViewModel>;
      })
    );
  }
  /**
   * @return Success
   */
  Get(): __Observable<ManifestModelEditorViewModel> {
    return this.GetResponse().pipe(
      __map(_r => _r.body as ManifestModelEditorViewModel)
    );
  }

  /**
   * @param manifestModel undefined
   * @return Success
   */
  SaveResponse(manifestModel?: ManifestModel): __Observable<__StrictHttpResponse<ManifestModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = manifestModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelEditorViewModel>;
      })
    );
  }
  /**
   * @param manifestModel undefined
   * @return Success
   */
  Save(manifestModel?: ManifestModel): __Observable<ManifestModelEditorViewModel> {
    return this.SaveResponse(manifestModel).pipe(
      __map(_r => _r.body as ManifestModelEditorViewModel)
    );
  }

  /**
   * @param manifestKey undefined
   * @return Success
   */
  GetByKeyResponse(manifestKey: string): __Observable<__StrictHttpResponse<ManifestModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/manifest/${manifestKey}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelEditorViewModel>;
      })
    );
  }
  /**
   * @param manifestKey undefined
   * @return Success
   */
  GetByKey(manifestKey: string): __Observable<ManifestModelEditorViewModel> {
    return this.GetByKeyResponse(manifestKey).pipe(
      __map(_r => _r.body as ManifestModelEditorViewModel)
    );
  }

  /**
   * @param params The `ManifestService.QueryParams` containing the following parameters:
   *
   * - `TransportType.MetadataKey`:
   *
   * - `TransportType.Key`:
   *
   * - `TransportType.Description`:
   *
   * - `TransportType.Active`:
   *
   * - `TransportNumber`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PatientList`:
   *
   * - `PatientCount`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `OperationKey`:
   *
   * - `MissionNumber`:
   *
   * - `ManifestNumber`:
   *
   * - `ManifestName`:
   *
   * - `ManifestDisposition.MetadataKey`:
   *
   * - `ManifestDisposition.Key`:
   *
   * - `ManifestDisposition.Description`:
   *
   * - `ManifestDisposition.Active`:
   *
   * - `Key`:
   *
   * - `ForExport`:
   *
   * - `Fcc.MetadataKey`:
   *
   * - `Fcc.Key`:
   *
   * - `Fcc.Description`:
   *
   * - `Fcc.Active`:
   *
   * - `FCCKey`:
   *
   * - `DispositionText`:
   *
   * - `DispositionDate`:
   *
   * - `DischargedDate`:
   *
   * - `DestinationFacility.MetadataKey`:
   *
   * - `DestinationFacility.Key`:
   *
   * - `DestinationFacility.Description`:
   *
   * - `DestinationFacility.Active`:
   *
   * - `CurrentLocation.MetadataKey`:
   *
   * - `CurrentLocation.Key`:
   *
   * - `CurrentLocation.Description`:
   *
   * - `CurrentLocation.Active`:
   *
   * - `AirheadCode`:
   *
   * @return Success
   */
  QueryResponse(params: ManifestService.QueryParams): __Observable<__StrictHttpResponse<ManifestModelQueryResponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.TransportTypeMetadataKey != null) __params = __params.set('TransportType.MetadataKey', params.TransportTypeMetadataKey.toString());
    if (params.TransportTypeKey != null) __params = __params.set('TransportType.Key', params.TransportTypeKey.toString());
    if (params.TransportTypeDescription != null) __params = __params.set('TransportType.Description', params.TransportTypeDescription.toString());
    if (params.TransportTypeActive != null) __params = __params.set('TransportType.Active', params.TransportTypeActive.toString());
    if (params.TransportNumber != null) __params = __params.set('TransportNumber', params.TransportNumber.toString());
    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    (params.PatientList || []).forEach(val => {if (val != null) __params = __params.append('PatientList', val.toString())});
    if (params.PatientCount != null) __params = __params.set('PatientCount', params.PatientCount.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.OperationKey != null) __params = __params.set('OperationKey', params.OperationKey.toString());
    if (params.MissionNumber != null) __params = __params.set('MissionNumber', params.MissionNumber.toString());
    if (params.ManifestNumber != null) __params = __params.set('ManifestNumber', params.ManifestNumber.toString());
    if (params.ManifestName != null) __params = __params.set('ManifestName', params.ManifestName.toString());
    if (params.ManifestDispositionMetadataKey != null) __params = __params.set('ManifestDisposition.MetadataKey', params.ManifestDispositionMetadataKey.toString());
    if (params.ManifestDispositionKey != null) __params = __params.set('ManifestDisposition.Key', params.ManifestDispositionKey.toString());
    if (params.ManifestDispositionDescription != null) __params = __params.set('ManifestDisposition.Description', params.ManifestDispositionDescription.toString());
    if (params.ManifestDispositionActive != null) __params = __params.set('ManifestDisposition.Active', params.ManifestDispositionActive.toString());
    if (params.Key != null) __params = __params.set('Key', params.Key.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FccMetadataKey != null) __params = __params.set('Fcc.MetadataKey', params.FccMetadataKey.toString());
    if (params.FccKey != null) __params = __params.set('Fcc.Key', params.FccKey.toString());
    if (params.FccDescription != null) __params = __params.set('Fcc.Description', params.FccDescription.toString());
    if (params.FccActive != null) __params = __params.set('Fcc.Active', params.FccActive.toString());
    if (params.FCCKey != null) __params = __params.set('FCCKey', params.FCCKey.toString());
    if (params.DispositionText != null) __params = __params.set('DispositionText', params.DispositionText.toString());
    if (params.DispositionDate != null) __params = __params.set('DispositionDate', params.DispositionDate.toString());
    if (params.DischargedDate != null) __params = __params.set('DischargedDate', params.DischargedDate.toString());
    if (params.DestinationFacilityMetadataKey != null) __params = __params.set('DestinationFacility.MetadataKey', params.DestinationFacilityMetadataKey.toString());
    if (params.DestinationFacilityKey != null) __params = __params.set('DestinationFacility.Key', params.DestinationFacilityKey.toString());
    if (params.DestinationFacilityDescription != null) __params = __params.set('DestinationFacility.Description', params.DestinationFacilityDescription.toString());
    if (params.DestinationFacilityActive != null) __params = __params.set('DestinationFacility.Active', params.DestinationFacilityActive.toString());
    if (params.CurrentLocationMetadataKey != null) __params = __params.set('CurrentLocation.MetadataKey', params.CurrentLocationMetadataKey.toString());
    if (params.CurrentLocationKey != null) __params = __params.set('CurrentLocation.Key', params.CurrentLocationKey.toString());
    if (params.CurrentLocationDescription != null) __params = __params.set('CurrentLocation.Description', params.CurrentLocationDescription.toString());
    if (params.CurrentLocationActive != null) __params = __params.set('CurrentLocation.Active', params.CurrentLocationActive.toString());
    if (params.AirheadCode != null) __params = __params.set('AirheadCode', params.AirheadCode.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/manifest/Query`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelQueryResponseViewModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.QueryParams` containing the following parameters:
   *
   * - `TransportType.MetadataKey`:
   *
   * - `TransportType.Key`:
   *
   * - `TransportType.Description`:
   *
   * - `TransportType.Active`:
   *
   * - `TransportNumber`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PatientList`:
   *
   * - `PatientCount`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `OperationKey`:
   *
   * - `MissionNumber`:
   *
   * - `ManifestNumber`:
   *
   * - `ManifestName`:
   *
   * - `ManifestDisposition.MetadataKey`:
   *
   * - `ManifestDisposition.Key`:
   *
   * - `ManifestDisposition.Description`:
   *
   * - `ManifestDisposition.Active`:
   *
   * - `Key`:
   *
   * - `ForExport`:
   *
   * - `Fcc.MetadataKey`:
   *
   * - `Fcc.Key`:
   *
   * - `Fcc.Description`:
   *
   * - `Fcc.Active`:
   *
   * - `FCCKey`:
   *
   * - `DispositionText`:
   *
   * - `DispositionDate`:
   *
   * - `DischargedDate`:
   *
   * - `DestinationFacility.MetadataKey`:
   *
   * - `DestinationFacility.Key`:
   *
   * - `DestinationFacility.Description`:
   *
   * - `DestinationFacility.Active`:
   *
   * - `CurrentLocation.MetadataKey`:
   *
   * - `CurrentLocation.Key`:
   *
   * - `CurrentLocation.Description`:
   *
   * - `CurrentLocation.Active`:
   *
   * - `AirheadCode`:
   *
   * @return Success
   */
  Query(params: ManifestService.QueryParams): __Observable<ManifestModelQueryResponseViewModel> {
    return this.QueryResponse(params).pipe(
      __map(_r => _r.body as ManifestModelQueryResponseViewModel)
    );
  }

  /**
   * @param params The `ManifestService.SavePatientsToManifestParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `addManifestPatients`:
   *
   * @return Success
   */
  SavePatientsToManifestResponse(params: ManifestService.SavePatientsToManifestParams): __Observable<__StrictHttpResponse<ManifestPatientsQueryModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.addManifestPatients;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest/${params.manifestKey}/SavePatientsToManifest`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestPatientsQueryModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.SavePatientsToManifestParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `addManifestPatients`:
   *
   * @return Success
   */
  SavePatientsToManifest(params: ManifestService.SavePatientsToManifestParams): __Observable<ManifestPatientsQueryModel> {
    return this.SavePatientsToManifestResponse(params).pipe(
      __map(_r => _r.body as ManifestPatientsQueryModel)
    );
  }

  /**
   * @param params The `ManifestService.GetAvailablePatientsParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * @return Success
   */
  GetAvailablePatientsResponse(params: ManifestService.GetAvailablePatientsParams): __Observable<__StrictHttpResponse<ManifestPatientsQueryModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.LastName != null) __params = __params.set('LastName', params.LastName.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FirstName != null) __params = __params.set('FirstName', params.FirstName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest/${params.manifestKey}/GetAvailablePatients`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestPatientsQueryModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.GetAvailablePatientsParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * @return Success
   */
  GetAvailablePatients(params: ManifestService.GetAvailablePatientsParams): __Observable<ManifestPatientsQueryModel> {
    return this.GetAvailablePatientsResponse(params).pipe(
      __map(_r => _r.body as ManifestPatientsQueryModel)
    );
  }

  /**
   * @param params The `ManifestService.GetAssignedPatientsParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * @return Success
   */
  GetAssignedPatientsResponse(params: ManifestService.GetAssignedPatientsParams): __Observable<__StrictHttpResponse<ManifestPatientsQueryModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.LastName != null) __params = __params.set('LastName', params.LastName.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FirstName != null) __params = __params.set('FirstName', params.FirstName.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest/${params.manifestKey}/GetAssignedPatients`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestPatientsQueryModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.GetAssignedPatientsParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `Skip`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `LastName`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * @return Success
   */
  GetAssignedPatients(params: ManifestService.GetAssignedPatientsParams): __Observable<ManifestPatientsQueryModel> {
    return this.GetAssignedPatientsResponse(params).pipe(
      __map(_r => _r.body as ManifestPatientsQueryModel)
    );
  }

  /**
   * @param params The `ManifestService.AddPatientParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `patientManifestMappingModel`:
   *
   * @return Success
   */
  AddPatientResponse(params: ManifestService.AddPatientParams): __Observable<__StrictHttpResponse<ManifestModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientManifestMappingModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest/${params.manifestKey}/AddPatient`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.AddPatientParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `patientManifestMappingModel`:
   *
   * @return Success
   */
  AddPatient(params: ManifestService.AddPatientParams): __Observable<ManifestModelEditorViewModel> {
    return this.AddPatientResponse(params).pipe(
      __map(_r => _r.body as ManifestModelEditorViewModel)
    );
  }

  /**
   * @param params The `ManifestService.RemovePatientParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `patientManifestMappingModel`:
   *
   * @return Success
   */
  RemovePatientResponse(params: ManifestService.RemovePatientParams): __Observable<__StrictHttpResponse<ManifestModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientManifestMappingModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/manifest/${params.manifestKey}/RemovePatient`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ManifestModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `ManifestService.RemovePatientParams` containing the following parameters:
   *
   * - `manifestKey`:
   *
   * - `patientManifestMappingModel`:
   *
   * @return Success
   */
  RemovePatient(params: ManifestService.RemovePatientParams): __Observable<ManifestModelEditorViewModel> {
    return this.RemovePatientResponse(params).pipe(
      __map(_r => _r.body as ManifestModelEditorViewModel)
    );
  }
}

module ManifestService {

  /**
   * Parameters for Query
   */
  export interface QueryParams {
    TransportTypeMetadataKey?: string;
    TransportTypeKey?: string;
    TransportTypeDescription?: string;
    TransportTypeActive?: boolean;
    TransportNumber?: string;
    Take?: number;
    SortOrder?: number;
    SortBy?: string;
    Skip?: number;
    PatientList?: Array<any>;
    PatientCount?: number;
    PageSize?: number;
    Page?: number;
    OperationKey?: string;
    MissionNumber?: string;
    ManifestNumber?: string;
    ManifestName?: string;
    ManifestDispositionMetadataKey?: string;
    ManifestDispositionKey?: string;
    ManifestDispositionDescription?: string;
    ManifestDispositionActive?: boolean;
    Key?: string;
    ForExport?: boolean;
    FccMetadataKey?: string;
    FccKey?: string;
    FccDescription?: string;
    FccActive?: boolean;
    FCCKey?: string;
    DispositionText?: string;
    DispositionDate?: string;
    DischargedDate?: string;
    DestinationFacilityMetadataKey?: string;
    DestinationFacilityKey?: string;
    DestinationFacilityDescription?: string;
    DestinationFacilityActive?: boolean;
    CurrentLocationMetadataKey?: string;
    CurrentLocationKey?: string;
    CurrentLocationDescription?: string;
    CurrentLocationActive?: boolean;
    AirheadCode?: string;
  }

  /**
   * Parameters for SavePatientsToManifest
   */
  export interface SavePatientsToManifestParams {
    manifestKey: string;
    addManifestPatients?: AddManifestPatientsModel;
  }

  /**
   * Parameters for GetAvailablePatients
   */
  export interface GetAvailablePatientsParams {
    manifestKey: string;
    Take?: number;
    SortOrder?: number;
    SortBy?: string;
    Skip?: number;
    PageSize?: number;
    Page?: number;
    LastName?: string;
    ForExport?: boolean;
    FirstName?: string;
  }

  /**
   * Parameters for GetAssignedPatients
   */
  export interface GetAssignedPatientsParams {
    manifestKey: string;
    Take?: number;
    SortOrder?: number;
    SortBy?: string;
    Skip?: number;
    PageSize?: number;
    Page?: number;
    LastName?: string;
    ForExport?: boolean;
    FirstName?: string;
  }

  /**
   * Parameters for AddPatient
   */
  export interface AddPatientParams {
    manifestKey: string;
    patientManifestMappingModel?: PatientManifestMappingModel;
  }

  /**
   * Parameters for RemovePatient
   */
  export interface RemovePatientParams {
    manifestKey: string;
    patientManifestMappingModel?: PatientManifestMappingModel;
  }
}

export { ManifestService }
